<template>
  <div class="upload">
    <ul class="upload-images">
      <li v-for="file in files" :key="file.file" class="uploaded-file">
        <v-img :src="file.original" width="120" height="120">
          <template v-slot:placeholder>
            <v-layout fill-height align-center justify-center ma-0>
              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
            </v-layout>
          </template>
        </v-img>
        <div class="mask" @click="lightbox(file)">
          <v-icon @click.stop="storageFileDelete(file)" v-if="!disabled">delete</v-icon>
        </div>
      </li>
      <li class="file-select" @click.stop="onFocus" v-if="!disabled && files.length < max">
        <v-layout fill-height align-center justify-center row>
          <div v-if="!uploading">
            <v-icon>attach_file</v-icon>
          </div>
          <div v-else>
            <v-progress-circular :value="progress_value" color="blue-grey"></v-progress-circular>
          </div>
        </v-layout>
      </li>
    </ul>
    <input ref="fileInput" type="file" accept="image/*" @change="onFileChange" />
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/storage'

export default {
  data() {
    return {
      uploading: false,
      progress_value: 0
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    files: {
      type: Array,
      default: () => ([])
    },
    max: {
      type: Number,
      default: 1
    }
  },
  methods: {
    onFocus() {
      this.$refs.fileInput.click()
    },
    onFileChange($e) {
      const files = $e.target.files || $e.dataTransfer.files
      const path = this
      if (files) {
        if (files.length > 0) {
          path.progress_value = 0
          path.uploading = true

          //添付ファイル
          var newFile = this.getUniqueName(files[0].name)
          var uploadTask = firebase.storage().ref().child('images/' + newFile).put(files[0])
          uploadTask.on('state_changed', function(snapshot) {
            var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            path.progress_value = progress
          }, function() {
            //console.log('写真のアップロードに失敗しました')
            path.uploading = false
          }, function() {
            uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
              path.uploading = false
              path.files.push({
                file: newFile,
                original: downloadURL
              })
            })
          })
        }
      }
    },
    storageFileDelete(item) {
      const path = this
      if (confirm('写真を削除しますか？')) {
        firebase.storage().ref().child('images/' + item.file).delete().then(function() {
          const index = path.files.indexOf(item)
          path.files.splice(index, 1)
        }).catch(() => {
          //console.log('写真の削除に失敗しました')
        })
      }
    },
    lightbox(item) {
      this.$emit('lightbox', item)
    },
    getUniqueName(fileName) {
      let reg = /(.*)(?:\.([^.]+$))/
      let st = 1000
      return new Date().getTime().toString(16) + Math.floor(st * Math.random()).toString(16) + '.' + fileName.match(reg)[2]
    }
  }
}
</script>

<style scoped>
input[type=file] {
  position: absolute;
  top: 0;
  left: -9999px;
}
ul.upload-images {
  list-style: none;
  margin: 0;
  padding: 0;
}
ul.upload-images li {
  display: inline-block;
  width: 120px;
  height: 120px;
  vertical-align: top;
  margin-right: 10px;
}
ul.upload-images li.file-select {
  border: 1px solid #CCC;
  border-radius: 5px;
  cursor: pointer;
}
ul.upload-images li.uploaded-file {
  position: relative;
}
ul.upload-images li.uploaded-file .mask {
  display: none;
}
ul.upload-images li.uploaded-file:hover .mask {
  display: block;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  border-radius: 5px;
}
ul.upload-images li.uploaded-file .mask i {
  position: absolute;
  right: 10px;
  top: 10px;
  color: #FFF;
  text-shadow: 0 0 5px #000, 0 0 5px #000;
}
ul.upload-images li.uploaded-file .mask i:hover {
  cursor: pointer;
}
ul.upload-images li .v-image {
  border-radius: 5px;
}
</style>
